import { useMemo } from 'react';

/**
 * Hook to format totals for cost fragments table display
 * 
 * @param {Object} totals - Totals object with s1308_claim, pnl_expenditure, rnd_amount, eligible_rnd_percentage
 * @returns {Object} Mapping of column names to their formatted total values
 */
export function useTotalsRow(totals) {
  // Build totalsRow mapping for TotalsCell
  const totalsRowMapping = useMemo(() => {
    if (!totals) {
      return {
        'Business Unit': 'Total',
        's1308 Claim': '0.00',
        'P&L R&D Expenditure': '0.00',
        'R&D Amount': '0.00',
        'Eligible R&D %': '0.00'
      };
    }
    return {
      'Business Unit': 'Total',
      's1308 Claim': (totals.s1308_claim || 0).toFixed(2),
      'P&L R&D Expenditure': (totals.pnl_expenditure || 0).toFixed(2),
      'R&D Amount': (totals.rnd_amount || 0).toFixed(2),
      'Eligible R&D %': (totals.eligible_rnd_percentage || 0).toFixed(2)
    };
  }, [totals]);
  return totalsRowMapping;
}